const ENReportsView = {
	"O campo {{name}} é requerido":"The field {{name}} is required",
	"Erro ao gerar relatório":"Error on generate report",
	"Gerar relatório":"Generate report",
	"Gerênciar relatórios": "Manage reports",
	"Visualizar relatórios": "View reports"
};

export default ENReportsView;
